var _style, _circle, _g, _g2, _path, _path2, _g3, _path3, _path4, _circle2, _g4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDm(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F0F0F0;}\n\t.st1{fill:#496E2D;}\n\t.st2{fill:#FFDA44;}\n\t.st3{fill:#D80027;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 256,
    cy: 256,
    r: 256
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M306.1,507.1c101.2-20.1,180.9-99.8,201-201h-201V507.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M4.9,306.1c20.1,101.2,99.8,180.9,201,201v-201H4.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M507.1,205.9C487,104.7,407.3,25,306.1,4.9v201H507.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M205.9,4.9C104.7,25,25,104.7,4.9,205.9h201V4.9z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M239.3,306.1h-33.4v201c10.9,2.2,22,3.6,33.4,4.4L239.3,306.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M239.3,205.9V0.6c-11.3,0.7-22.5,2.2-33.4,4.4v201H239.3z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M272.7,0.6C267.2,0.2,261.6,0,256,0s-11.2,0.2-16.7,0.6v205.4h33.4L272.7,0.6L272.7,0.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M239.3,511.4c5.5,0.4,11.1,0.6,16.7,0.6s11.2-0.2,16.7-0.6V306.1h-33.4L239.3,511.4L239.3,511.4z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M205.9,239.3v-33.4H4.9c-2.2,10.9-3.6,22-4.4,33.4L205.9,239.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M306.1,239.3h205.4c-0.7-11.3-2.2-22.5-4.4-33.4h-201L306.1,239.3L306.1,239.3z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M306.1,272.7h205.4c0.4-5.5,0.6-11.1,0.6-16.7s-0.2-11.2-0.6-16.7H306.1L306.1,272.7z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.6,239.3C0.2,244.8,0,250.4,0,256s0.2,11.2,0.6,16.7h205.4v-33.4L0.6,239.3L0.6,239.3z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 256,
    cy: 256,
    r: 122.4
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M283.9,269.7C274.8,251.4,263,233,263,233s0.3-8.4,0.3-13.4c0-7.5-6.1-13.7-13.7-13.7c-7.1,0-13,5.5-13.6,12.5 c-5.6,0.4-10.1,5-10.1,10.7c0,4.2,2.4,7.8,5.8,9.6c1.7-4,5.1-7.1,9.2-8.6c0.7,0.6,1.4,1,2.2,1.5l1.8,0.8c0,0-6.5,18.3-6.5,28.1 c0,27.6,18.2,36.1,18.2,36.1v0.3l-9.1,9.1h18.2v-18.2l9.1,9.1C274.9,296.8,292,286,283.9,269.7L283.9,269.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M256,155.8l4.1,12.8h13.4l-10.8,7.9l4.1,12.8l-10.9-7.9l-10.9,7.9l4.1-12.8l-10.8-7.9h13.4L256,155.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M197.1,175l10.8,7.9l10.9-7.9l-4.1,12.8l10.9,7.9l-13.4,0l-4.1,12.8l-4.1-12.8l-13.4,0l10.8-7.9L197.1,175z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M160.7,225h13.4l4.1-12.8l4.1,12.8l13.4,0l-10.8,7.9l4.1,12.8l-10.9-7.9l-10.8,7.9l4.1-12.8L160.7,225z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M160.7,287l10.8-7.9l-4.1-12.8l10.9,7.9l10.9-7.9l-4.1,12.8l10.9,7.9l-13.4,0l-4.1,12.8l-4.1-12.8L160.7,287z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M197.1,337l4.1-12.8l-10.9-7.9h13.4l4.1-12.8l4.1,12.8h13.4l-10.9,7.9l4.1,12.8l-10.9-7.9L197.1,337z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M256,356.2l-4.1-12.8h-13.4l10.8-7.9l-4.1-12.8l10.9,7.9l10.8-7.9l-4.1,12.8l10.8,7.9l-13.4,0L256,356.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M314.9,337l-10.8-7.9l-10.8,7.9l4.1-12.8l-10.9-7.9l13.4,0l4.1-12.8l4.1,12.8h13.4l-10.8,7.9L314.9,337z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M351.3,287h-13.4l-4.1,12.8l-4.1-12.8h-13.4l10.9-7.9l-4.1-12.8l10.9,7.9l10.8-7.9l-4.1,12.8L351.3,287z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M351.3,225l-10.8,7.9l4.1,12.8l-10.8-7.9l-10.9,7.9l4.1-12.8l-10.9-7.9l13.4,0l4.1-12.8l4.1,12.8H351.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M314.9,175l-4.1,12.8l10.8,7.9h-13.4l-4.1,12.8l-4.1-12.8l-13.4,0l10.9-7.9l-4.1-12.8l10.9,7.9L314.9,175z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDm);
export default __webpack_public_path__ + "static/media/dm.57a48ce2738a9fd75e43e692b56a7783.svg";
export { ForwardRef as ReactComponent };